import {
  faCircleCheck,
  faCircleDown,
  faCircleUp,
  faCircleXmark,
} from '@fortawesome/free-solid-svg-icons';

export const getColor = (difference: number | null) => {
  if (difference === null) return '#f5222d';
  if (difference > 0) return '#1677ff';
  if (difference < 0) return '#f5222d';
  if (difference === 0) return '#52c41a';
  return '#f5222d';
};

export const getBadgeStyle = (
  difference: number | null
): { backgroundColor: string; color: string } => {
  if (difference === null)
    return { backgroundColor: '#fff1f0', color: '#a8071a' };
  if (difference > 0) return { backgroundColor: '#e6f7ff', color: '#0958d9' };
  if (difference < 0) return { backgroundColor: '#fff1f0', color: '#a8071a' };
  if (difference === 0) return { backgroundColor: '#f6ffed', color: '#237804' };
  return { backgroundColor: '#fff1f0', color: '#a8071a' };
};

export const getIcon = (difference: number | null) => {
  if (difference === null) return faCircleXmark;
  if (difference > 0) return faCircleUp;
  if (difference < 0) return faCircleDown;
  if (difference === 0) return faCircleCheck;
  return faCircleXmark;
};

export const getDifferenceSymbol = (difference: number | null) => {
  if (difference === null) return '';
  if (difference > 0) return '+';
  if (difference < 0) return '-';
  return '';
};
